export default "/react/logoAndata-71158318.png";